import type { AnalysisState } from '@aibi/contracts';
import {
  isGeographicDimension,
  isTemporalDimension,
  type SemanticModelIndex,
} from '@aibi/semantic-model';

/**
 * Resumen estructural de una consulta: cuantas dimensiones/medidas tiene y de que
 * naturaleza. Permite decidir que visualizaciones son compatibles sin mirar datos.
 */
export interface QueryShape {
  readonly dimensionCount: number;
  readonly measureCount: number;
  readonly temporalDimensionCount: number;
  readonly geographicDimensionCount: number;
}

export function describeQueryShape(
  state: Pick<AnalysisState, 'dimensions' | 'measures'>,
  index: SemanticModelIndex,
): QueryShape {
  let temporal = 0;
  let geographic = 0;
  for (const dimension of state.dimensions) {
    const resolved = index.resolveDimension(dimension.dimensionId);
    if (!resolved) continue;
    if (dimension.timeGrain !== undefined || isTemporalDimension(resolved)) temporal += 1;
    if (isGeographicDimension(resolved)) geographic += 1;
  }
  return {
    dimensionCount: state.dimensions.length,
    measureCount: state.measures.length,
    temporalDimensionCount: temporal,
    geographicDimensionCount: geographic,
  };
}
